import { gql } from '@apollo/client'

export const UPDATE_CITY = gql`
  mutation updateCity($input: UpdateCityInput!) {
    data: updateCity(input: $input) {
      id
    }
  }
`
